import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { DataTableModule } from "@bfx/primeng/datatable";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";

import { BfxOrderCancelComponent } from "./bfx-order-cancel.component";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    BfxElementsLibraryModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    BaseComponentsModule,
    AgGridModule.withComponents([]),
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxOrderCancelComponent],
  exports: [BfxOrderCancelComponent],
  bootstrap: [BfxOrderCancelComponent],
})
export class BfxOrderCancelModule {}
